module.exports = __webpack_public_path__ + "img/shutter.6db85d01.svg";